import baseUrl from '../baseUrl';
import isTokenExpired from '../../helpers/isTokenExpired';

const ENDPOINT = `${baseUrl}/suprimentos/medicamentos`;

function checkToken() {
    const token = window.localStorage.getItem('token');

    if (token) {
        if (isTokenExpired(token)) {
          window.localStorage.clear();
          window.location.replace('/');

          return isTokenExpired(token);
        }
    }
}

export const medicamentosService = {
    async get(id) {
        const data = await fetch(`${ENDPOINT}/${id}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();

        return response;
    },
    async allMedicamentos(campo = '', valor = '', pageNumber = 1, limit = 50, filterBy = 'createdAt', orderBy = 'desc') {
        if (checkToken()) return;

        const data = await fetch(
            `${ENDPOINT}?page=${pageNumber}&campo=${campo}&valor=${valor}&limit=${limit}&filterBy=${filterBy}&orderBy=${orderBy}`, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            }
        );

        const response = await data.json()

        return response;
    },
    async update(id, values) {
        const data = await fetch(`${ENDPOINT}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(values)
        });

        const response = await data.json();
        return response;
    },
    async delete(id) {
        const response = await fetch(`${ENDPOINT}/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        return response;
    },
    async create(data) {
        const response = await fetch(ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        });

        return response;
    },
};
